export enum DatePickerAppearanceEnum {
  Standard = 'standard',
  Legacy = 'Legacy',
  Fill = 'fill',
  Outline = 'outline',
  None = 'none',
}
